import { TOKEN_KEY } from "./Constants";

export const checkAuth = (res) => {

    if (res.status === 401) {

        if (localStorage.getItem(TOKEN_KEY) !== null) {

            localStorage.removeItem(TOKEN_KEY);
            window.location.reload();
        }
    }
    return res.json();
}